import type { IncomingEvent } from "@ws-usage/pi3-typescript/src/event/incoming-event";

export enum EventButton {}
export enum ElementButton {
  LOGIN = "login",
  COLLAPSE = "collapse",
  EXPAND = "expand",
  POLICIES = "policies",
  DOMAINS = "domains",
  SETTINGS = "settings",
  LOGS = "logs",
  CUSTOM_DISCLAIMERS = "custom-disclaimers",

  // domain page
  APPROVE = "approve",
  SUSPEND = "suspend",
  BULK_ASSIGNMENT = "bulk assignment",
  SYNC_FEED = "sync feed",
  CANCEL = "cancel",

  // policy page
  SYNC_POLICY = "sync policy",
  ADD_POLICY = "add policy",
  MANAGE_RANK = "manage rank",
  "SAVE" = 'save',

  // custom disclaimers page
  NEW_POLICY_DISCLAIMER = "new-policy-disclaimer",
  ACCEPT_PERMISSIONS = "accept-permissions",
  VIEW_DISCLAIMER_LOGS = "view-disclaimer-logs",
  SAVE_DISCLAIMER = "save-disclaimer",
  CANCEL_DISCLAIMER = "cancel-disclaimer",
  DELETE_DISCLAIMER = "delete-disclaimer",

  // onboarding
  VIEW_TERMS_AND_CONDITIONS = "view-terms-and-conditions",
  ACCEPT_TERMS_AND_CONDITIONS = "accept-terms-and-conditions",
  CONTINUE = "continue",
  BACK = "back",
  SUBMIT_API_KEY = "submit-api-key",
  GO_TO_POLICIES = "go-to-policies",
  TRY_AGAIN = "try-again",

  // logs page
  REFRESH = "refresh",
  EXPORT = "export",
  EXPORT_CSV = "export-csv",
  EXPORT_JSON = "export-json",
  SEARCH = "search",
  APPLY_FILTER = "apply-filter",
  EXPAND_ROW = "expand-row",
  COLLAPSE_ROW = "collapse-row",

  // settings navigation
  GENERAL_CONFIGURATION = "general-configuration",
  TENANT_CONFIGURATION = "tenant-configuration",
  EMAIL_NOTIFICATION_SETTINGS = "email-notification-settings",
  DOMAIN_FEED_CONFIGURATION = "domain-feed-configuration",
  SYSTEM_STATUS_HEALTH = "system-status-health",

  // settings actions
  SAVE_SETTINGS = "save-settings",
  SEND_TEST_EMAIL = "send-test-email",
  SYNC_DOMAINS_NOW = "sync-domains-now",
  GENERATE_NEW_API_KEY = "generate-new-api-key",
  TEST_CONNECTION = "test-connection",
  SAVE_CONFIGURATION = "save-configuration"
}

export enum EventName {
  LOGIN = "Login",
  APP_LAUNCHED = "AppLaunched",
  TAB_LAUNCHED = "TabLaunched",
  BUTTON_CLICKED = "Button-Clicked",
  ELEMENT_CLICKED = "ElementClicked",
  COMPONENT_LOADED = "ComponentLoaded",
  PAGE_LOADED = "PageLoaded",
  ONBOARDING_COMPLETED = "OnboardingCompleted",
  UNKNOWN = "Unknown",
}

export enum PageName {
  MENU = "menu",
  LOGIN = "login",
  POLICIES = "policies",
  DOMAINS = "domains",
  POLICY_DETAIL = "policy-detail",
  LOGS = "logs",
  SETTINGS = "settings",
  ONBOARDING_TERMS = "onboarding-terms",
  ONBOARDING_API_KEY = "onboarding-api-key",
  ONBOARDING_SETUP = "onboarding-setup",
  ADD_POLICY = "add-policy",
  SETTINGS_EMAIL_NOTIFICATIONS = "settings-email-notifications",
  SETTINGS_DOMAIN_FEED = "settings-domain-feed",
  CUSTOM_DISCLAIMERS = "custom-disclaimers",
  CREATE_DISCLAIMER = "create-disclaimer",
  EDIT_DISCLAIMER = "edit-disclaimer",
}

export enum TabName {
  PENDING = "Pending",
  APPROVED = "Approved",
  SUSPENDED = "Suspended",
}

export type PageNameType = `${PageName}`;
export type TabNameType = `${TabName}`;
export type EventNameType = `${EventName}`;
export type EventButtonType = `${EventButton}`;
export interface TrackingEvent extends IncomingEvent {}
export interface IUsageTracking {
  initialize: (ftlData: any) => Promise<void>;
  setEventName: (eventName: string) => void;
  setPiiData: (piiData: Record<string, unknown>) => this;
  setNonPiiData: (piiDnonata: Record<string, unknown>) => this;
  eventTracker(): Promise<void>;
}
